/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import { Button, Stack } from '@mui/material';
import { WebViewerInstance } from '@pdftron/webviewer';
import Markdown, { RuleType } from 'markdown-to-jsx';

import { highlightedSentence } from '../../hooks/Helper';
import { setCitation } from '../../Pages/Drafts/DraftSlice';
import { RootState, useAppDispatch, useTypedSelector } from '../../redux/store';

const removeStyle = (highlightedDiv: any) => {
  const child = highlightedDiv.childNodes;
  child.forEach((childS: any) => {
    if (childS.nodeType === 3) {
      (highlightedDiv as any).style.removeProperty('background-color');
      (highlightedDiv as any).style.removeProperty('cursor');
      (highlightedDiv as any).removeEventListener('click', function () {
        highlightedSentence(childS.textContent);
        (highlightedDiv as any).style.removeProperty('background-color');
      });
    } else {
      (childS as any).style.removeProperty('background-color');
      (highlightedDiv as any).removeEventListener('click', function () {
        highlightedSentence(childS.textContent);
        (highlightedDiv as any).style.removeProperty('background-color');
      });
    }
  });
};

const addHighlightFnInMessage = (
  highlightedDiv: any,
  instance: WebViewerInstance
) => {
  if (highlightedDiv) {
    const child = highlightedDiv?.childNodes || [];
    child.forEach((childNode: any) => {
      if (childNode.nodeType === 3) {
        highlightedDiv.addEventListener('click', function () {
          highlightedSentence(childNode.textContent, instance);
          removeStyle(highlightedDiv);
          (highlightedDiv as any).style.backgroundColor = '#FFEDAD';
        });
        (highlightedDiv as any).style.cursor = 'pointer';
      } else {
        childNode.addEventListener('click', function (e: MouseEvent) {
          e.preventDefault();
          highlightedSentence(childNode.textContent, instance);
          removeStyle(highlightedDiv);
          (childNode as any).style.backgroundColor = '#FFEDAD';
        });
        (childNode as any).style.cursor = 'pointer';
      }
    });
  }
};

const UltraResponse = ({ payload }: any) => {
  const [activeCitation, setActiveCitation] = useState<{
    id: string;
    citationId: number;
  } | null>(null);
  const { instance } = useTypedSelector((state: RootState) => state.draft);
  const dispatch = useAppDispatch();

  return (
    <Stack className="chat-bot-response-container">
      <div className="ultra-response-chat-bot-message">
        <Markdown
          options={{
            renderRule(next: any, node: any, _: any, state: any) {
              if (node.type === RuleType.text && node.text.includes('[doc')) {
                const numb = node.text.slice(-1);
                return (
                  <sup key={state.key}>
                    <a id={`ref${numb}`}>[{numb}]</a>
                  </sup>
                );
              }

              if (node.type === RuleType.text && node.text === '].') {
                return '.';
              }

              return next();
            },
          }}
        >
          {payload.botMessage || ''}
        </Markdown>
      </div>
      {payload.citations.length > 0 && (
        <Stack style={{ flexDirection: 'row', gap: 10, flexWrap: 'wrap' }}>
          {payload.citations.map((_: any, index: number) => (
            <Button
              key={index}
              variant={
                activeCitation?.id === payload.id &&
                activeCitation?.citationId === index
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() => {
                localStorage.removeItem('persist:search-wc-document-viewer');
                localStorage.removeItem('persist:viewer-wc-document-viewer');
                localStorage.removeItem(
                  'persist:office-editor-wc-document-viewer'
                );
                setActiveCitation((prev) => {
                  if (prev) {
                    const removeDiv = document.getElementById(
                      `highlight-${prev.id}-${prev?.citationId}`
                    );
                    removeStyle(removeDiv);
                  }
                  return { id: payload.id, citationId: index };
                });
                dispatch(
                  setCitation({
                    title: payload.citations[index].title,
                    url: payload.citations[index].url,
                  })
                );
                setTimeout(() => {
                  const highlightedDiv = document.getElementById(
                    `highlight-${payload.id}-${index}`
                  );
                  addHighlightFnInMessage(highlightedDiv, instance);
                }, 1000);
              }}
            >{`Citation ${index + 1}`}</Button>
          ))}
        </Stack>
      )}
      {activeCitation?.id === payload.id && (
        <div className="chat-bot-citation-con">
          <Markdown>{`<div id="highlight-${activeCitation?.id}-${activeCitation?.citationId}">${
            payload.citations?.[activeCitation?.citationId || 0]?.content
          }</div>`}</Markdown>
        </div>
      )}
    </Stack>
  );
};

export default UltraResponse;
